import { createSlice } from '@reduxjs/toolkit';

export interface TDataRefreshPanel {
  panelOpen: boolean;
}

const initialState: TDataRefreshPanel = {
  panelOpen: false,
};

const dataRefreshPanelDuck = createSlice({
  name: 'dataRefreshPanel',
  initialState,
  reducers: {
    openDataRefreshPanel: (state) => {
      state.panelOpen = true;
    },
    closeDataRefreshPanel: (state) => {
      state.panelOpen = false;
    },
  },
});

export const { openDataRefreshPanel, closeDataRefreshPanel } = dataRefreshPanelDuck.actions;
export default dataRefreshPanelDuck.reducer;
